module.exports = __webpack_public_path__ + "static/media/1tldrs.2cdb7952.png";